import * as React from 'react';

import { getCurrentDeviceKind, shouldUseMobileApp } from '../lib/deviceClassification';
import { readEnvBoolean } from '../lib/env';
import { useIsMobile } from './use-is-mobile';

/**
 * Returns true when the mobile UI is enabled and the viewport is mobile-sized.
 * Keep all flag + breakpoint logic centralized so mobile gating stays consistent.
 */
export function useIsMobileActive(): boolean {
  const isMobileViewport = useIsMobile();
  const isMobileFeatureEnabled = readEnvBoolean('VITE_MOBILE_APP_ENABLED');
  const [deviceKind, setDeviceKind] = React.useState(() => getCurrentDeviceKind());

  React.useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const updateDeviceKind = () => setDeviceKind(getCurrentDeviceKind());
    updateDeviceKind();

    window.addEventListener('resize', updateDeviceKind);
    window.addEventListener('orientationchange', updateDeviceKind);
    return () => {
      window.removeEventListener('resize', updateDeviceKind);
      window.removeEventListener('orientationchange', updateDeviceKind);
    };
  }, []);

  return shouldUseMobileApp({
    featureEnabled: isMobileFeatureEnabled,
    isMobileViewport,
    deviceKind,
  });
}
